module.exports = __webpack_public_path__ + "media/images/river/vintage-296fd29fe0f73d9b92527bf49fd98280.jpg";